import { stringField } from 'common/utils/form/fieldTypes';

const config = {
  username: stringField({ initialValue: '', required: true }),
  password: stringField({ initialValue: '', required: true })
};

export default config;
